import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, EventEmitter, Output, inject, OnInit } from '@angular/core';
import { ScoreFormat } from '../../_shared/models/score-format.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/auth.service';
import { TableTennisGameFormat, TableTennisGameType } from '../../_shared/models/enums/table-tennis.enum';

@Component({
  selector: 'app-table-tennis-match-format-form',
  templateUrl: './table-tennis-match-format-form.component.html',
  styleUrls: ['./table-tennis-match-format-form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class TableTennisMatchFormatFormComponent  implements OnInit {
  private fb = inject(FormBuilder);
  private bhs = inject(BoardHelpService);
  public authService = inject(AuthService);
  private translateService = inject(TranslateService);

  @Input() matchFormat = 'SET5-S:TB11';
  @Input() dividerTitle = this.translateService.instant('Score format');
  @Output() updatedMatchFormat = new EventEmitter();
  scoreFormat!: ScoreFormat;
  form!: FormGroup;

  ngOnInit() {
    if (!this.matchFormat) this.matchFormat = 'SET5-S:TB11';
    this.scoreFormat = this.bhs.getScoreFormat(this.matchFormat, DisciplineEnum.TABLE_TENNIS);
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      gameType: [TableTennisGameType.RALLY],
      numberOfGames: [this.scoreFormat.numberOfSets || 5],
      numberOfPoints: [this.scoreFormat.numberOfPointsInGame || 11],
      gameFormat: [TableTennisGameFormat.WIN_BY_2],
    });

    this.form
      .valueChanges
      .subscribe(
        () => {
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );

    this.updatedMatchFormat.emit(this.getMatchFormat())
  }

  // SET5-S:TB11 (Table Tennis - no cap, always win by 2)
  private getMatchFormat() {
    const formValue = this.form.getRawValue();
    const sets = 'SET' + formValue.numberOfGames;
    const games = `-S:TB${formValue.numberOfPoints}`;
    return sets + games;
  }

  // Header for action sheet
  customOptions(header) {
    return { header };
  }
}